import React, { useEffect } from 'react';
import {
    DateInput,
    required,
    TextInput,
    TabbedForm,
    FormTab,
    Edit,
    SelectInput,
    CardActions,
    ListButton,
    Toolbar,
    ShowButton,
    SaveButton,
    TextField,
    DateField,
    showNotification,
    ImageInput,
    ImageField,

} from 'react-admin';
import { useForm } from 'react-final-form';
import withStyles from '@material-ui/core/styles/withStyles';
import jwt_decode from 'jwt-decode'
import allStates from './AllStates';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Sign from '../controls/Signature';
import SanitizedTextInput from '../controls/SanitizedTextInput';
import ErrorBoundary from '../ErrorBoundary';

var donorSign = null ;
var data = null;

const SetDefaultValue = ({ source, value }) => {
    //console.log( 'source:' + source + '  value:' + value)
    const form = useForm();
    useEffect(() => {
        form.change(source, value);
    }, [form, source, value]);  // Dependencies ensure the effect runs only when needed

    return null;  // This component does not render anything
};

const DonorTitle = ({ record }) => (
    <span>Donor: {record.last_name},  {record.first_name}</span>
)

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const DonorEditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ShowButton basePath={basePath} record={data} />
        <ListButton basePath={basePath} />
    </CardActions>
);

const DonorCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save and show"
            redirect="show"
            transform={data => ({ ...data, donor_sign: donorSign })}
            submitOnEnter={false}
            style={{marginRight:'1em'}}
        />

        <SaveButton
            label="save and Exit"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

const styles = {
    inlineBlock: {
        display: 'inline-flex',
        marginRight: '1rem'
    },
    hidden: {
        display: 'none'
    }

};


const genderValues = [
    {
        id: 'Male',
        name: 'Male'
    },
    {
        id: 'Female',
        name: 'Female'
    },
    {
        id: 'Other',
        name: 'Other'
    }
]

const diferralCodes = [
    {
        id: 'ID',
        name: 'Indefinitely Deferred'
    },
    {
        id: 'N/A',
        name: 'Not applicable'
    },
    {
        id: 'PR',
        name: 'Permanently rejected'
    },
    {
        id : 'TD',
        name: 'Temporarly Deferred'
    }
]

/*
const MyCustomTag = ({ record }) => {
    useEffect(() => {
        // Perform actions after the component has mounted
        // and record is available
        console.log('Record:', record);
        return (<div>Hello</div>);
    }, [record]);

    // Rest of your component logic
    // ...
};
*/


const setDonSignatureValue=(image)=>{
    donorSign = image;
}

const SetData=({record})=>(
    data = record,
    <div></div>
)

     
    
const DonorEdit = ({ classes, ...props }) => (
    <ErrorBoundary>
    <Edit actions={<DonorEditActions />}   {...props} title={<DonorTitle />}   >
      
      <TabbedForm  toolbar={<DonorCreateToolbar />}>
      <FormTab label="Identity">
        <SetData />
            <Table style={{ margin: 'auto',  fontSize:'12px', cellspacing:"3", borderWidth:"1", width:"100%"}} >
            <TableBody  >
                <TableRow >
                        <TableCell  ><SanitizedTextInput source="ssn"  label="SSN"  validate={required()}/></TableCell>
                        <TableCell  ><SanitizedTextInput source="first_name"   label="First Name" validate={required()}/></TableCell  >
                        <TableCell  ><SanitizedTextInput source="last_name"   label="Last Name" validate={required()} /> </TableCell  >
                </TableRow>
                <TableRow>
                    <TableCell  ><SanitizedTextInput source="middle_name"   label="Middle Name" /></TableCell>
                    <TableCell  ><DateInput source="dob"    label="DOB" validate={required()} locales="en-us"/></TableCell>
                    <TableCell  ><SelectInput source="gender" lable="Gender"  choices={genderValues} validate={required()} /></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell  ><TextInput source="apt"   label="Apt/Suit#" /></TableCell>
                    <TableCell  ><SanitizedTextInput source="street"   label="Street" validate={required()} /></TableCell>
                    <TableCell  ><SanitizedTextInput source="city"   label="City" validate={required()}/></TableCell>
                </TableRow>
                <TableRow>
                    <TableCell  ><SanitizedTextInput source="zip"    label="Zip" /></TableCell>
                    <TableCell  ><SelectInput source="state"  label="State" choices={allStates}/></TableCell>
                    <TableCell  ><SanitizedTextInput source="don_ph"  label="Phone"/></TableCell>
                </TableRow>
                <TableRow>
                   
                    <TableCell >Donor Signature :&nbsp;&nbsp;</TableCell>
                    <TableCell colSpan="2"><Sign   setSignatureValue={setDonSignatureValue}  url={data?data.donor_signature: null} /></TableCell  >
                </TableRow>
                </TableBody>
            </Table>
        </FormTab>
        <FormTab label="Deferral">
            <SelectInput source="deferral_code"    label="Deferral code" choices={diferralCodes}  validate={required()} defaultValue={'N/A'}/>
            <DateInput source="deferral_date"    label="Deferral date" locales="en-us"  />
            <DateInput source="deferral_exp_date"    label="Deferral Exp date" locales="en-us"  />
            <DateInput source="created_date"    label="Created date" locales="en-us"  className={classes.hidden} defaultValue={new Date()}/>
            <SanitizedTextInput source="created_by"    label="Created by"  className={classes.hidden} defaultValue= {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).user_name : '' )}  />
            <TextInput source="deferral_comments"   rowsMax={4} multiline fullWidth  label="Deferral comments"/>
            <DateInput source="last_mod_date"    label="Last modifyed date" locales="en-us"  className={classes.hidden} defaultValue={new Date()}/>
            <SetDefaultValue source="last_mod_by"    label="Modifyed by" className={classes.hidden} value= {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).user_name : '' )}  />
            <SanitizedTextInput source="location"    label=""  className={classes.hidden} defaultValue= {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).location : '' )}  />
        </FormTab>

        <FormTab label="Allergies">
            <SanitizedTextInput source="allergies" rowsMax={4} multiline fullWidth  label="Allergies"/>
        </FormTab>
        <FormTab label="Photo/ID">
        <lable>Donor photo (Add/Edit)</lable>
            <ImageInput source="pictures" label="" accept="image/*" minSize={0} maxSize={2000000}>
                <ImageField source="src" title="Donor" />
            </ImageInput>
            <lable>Donor photo (View)</lable>
            <ImageField source="photo_url" label="" />
            <br />
            <lable>Social Security Number proof (Add/Edit)</lable>
            <ImageInput source="photo_id_1" label="" accept="image/*" minSize={0} maxSize={2000000}>
                <ImageField source="src" title="One" />
            </ImageInput>
            <lable>Social Security Number proof (View)</lable>
            <ImageField source="photo_id_1_url" label="" />
            <br />
            <lable>Address proof (Add/Edit)</lable>
            <ImageInput source="photo_id_2" label="" accept="image/*" minSize={0} maxSize={2000000}>
                <ImageField source="src" title="Two" />
            </ImageInput>
            <lable>Address proof (View)</lable>
            <ImageField source="photo_id_2_url" label="" />
        </FormTab>
      </TabbedForm>

    </Edit>
    </ErrorBoundary>
);
export default withStyles(styles)(DonorEdit);
